// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Config$SmartcutsMacros = require("./Config.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../bs-utils/src/DeccoUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var Browser__Tabs$SmartcutsMacros = require("./browser/Browser__Tabs.bs.js");

var schemaVersion = "0.0.1";

function t_encode(v) {
  if (v) {
    return [
            "StartOnTab",
            Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._0)
          ];
  } else {
    return ["StartOnNewWindow"];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "StartOnNewWindow" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* StartOnNewWindow */0
                  };
          }
      case "StartOnTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* StartOnTab */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(context) {
  if (!context) {
    return "StartOnNewWindow";
  }
  var arg = context._0.id;
  return "StartOnTab(tabId=" + ((function (param) {
                return OptionUtils$SmartcutsMacros.stringify(param, arg);
              })(function (prim) {
                return String(prim);
              }) + ")");
}

var StartContext = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  if (v) {
    return ["DocumentExecCommand"];
  } else {
    return ["BgDispatchShortcutKeys"];
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgDispatchShortcutKeys" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDispatchShortcutKeys */0
                  };
          }
      case "DocumentExecCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DocumentExecCommand */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var FallbackStrategy = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function t_encode$2(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["DocumentExecCommand"];
    } else {
      return ["BgDispatchShortcutKeys"];
    }
  } else {
    return [
            "AttemptEmitFakePasteWithFallback",
            t_encode$1(v._0)
          ];
  }
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AttemptEmitFakePasteWithFallback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* AttemptEmitFakePasteWithFallback */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "BgDispatchShortcutKeys" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDispatchShortcutKeys */0
                  };
          }
      case "DocumentExecCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DocumentExecCommand */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var HybridPlaybackStrategy__PasteStrategy = {
  FallbackStrategy: FallbackStrategy,
  t_encode: t_encode$2,
  t_decode: t_decode$2
};

function t_encode$3(v) {
  return Js_dict.fromArray([[
                "pasteStrategy",
                t_encode$2(v.pasteStrategy)
              ]]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var pasteStrategy = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict._0, "pasteStrategy"), null));
  if (pasteStrategy.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              pasteStrategy: pasteStrategy._0
            }
          };
  }
  var e = pasteStrategy._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".pasteStrategy" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var HybridPlaybackStrategy = {
  t_encode: t_encode$3,
  t_decode: t_decode$3
};

function t_encode$4(v) {
  if (v) {
    return [
            "Hybrid",
            t_encode$3(v._0)
          ];
  } else {
    return ["ContentScriptOnly"];
  }
}

function t_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContentScriptOnly" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ContentScriptOnly */0
                  };
          }
      case "Hybrid" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Hybrid */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var PlaybackStrategy = {
  t_encode: t_encode$4,
  t_decode: t_decode$4
};

function t_encode$5(v) {
  if (v) {
    return ["UseVirtualAndNativeClipboard"];
  } else {
    return ["OnlyUseVirtualClipboard"];
  }
}

function t_decode$5(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OnlyUseVirtualClipboard" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* OnlyUseVirtualClipboard */0
                  };
          }
      case "UseVirtualAndNativeClipboard" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UseVirtualAndNativeClipboard */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var ClipboardBehavior = {
  t_encode: t_encode$5,
  t_decode: t_decode$5
};

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "millisecondsBetweenCommands",
                Decco.intToJson(v.millisecondsBetweenCommands)
              ],
              [
                "millisecondsBetweenTypingCharacter",
                Decco.intToJson(v.millisecondsBetweenTypingCharacter)
              ],
              [
                "millisecondsBetweenKeyDownKeyUp",
                Decco.intToJson(v.millisecondsBetweenKeyDownKeyUp)
              ],
              [
                "millisecondsBetweenTypingCharacterAndNonCharacterKeypress",
                Decco.intToJson(v.millisecondsBetweenTypingCharacterAndNonCharacterKeypress)
              ],
              [
                "useFastestTypePlayback",
                Decco.boolToJson(v.useFastestTypePlayback)
              ],
              [
                "preserveClipboard",
                Decco.boolToJson(v.preserveClipboard)
              ],
              [
                "clipboardBehavior",
                Decco.optionToJson(t_encode$5, v.clipboardBehavior)
              ],
              [
                "startContext",
                t_encode(v.startContext)
              ],
              [
                "closeWindowWhenFinish",
                Decco.boolToJson(v.closeWindowWhenFinish)
              ],
              [
                "doNotFocus",
                Decco.boolToJson(v.doNotFocus)
              ],
              [
                "playbackStrategy",
                t_encode$4(v.playbackStrategy)
              ],
              [
                "replaceUiCommandsWithApiCommands",
                Decco.boolToJson(v.replaceUiCommandsWithApiCommands)
              ],
              [
                "msBeforeNextCommand",
                Decco.arrayToJson(Decco.intToJson, v.msBeforeNextCommand)
              ],
              [
                "selectorTimeout",
                Util$SmartcutsMacros.HasDefault.t_encode(Decco.floatToJson, v.selectorTimeout)
              ],
              [
                "domSnapshots",
                Decco.boolToJson(v.domSnapshots)
              ],
              [
                "doNotShowSplashScreen",
                Decco.boolToJson(v.doNotShowSplashScreen)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var millisecondsBetweenCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenCommands"), null));
  if (millisecondsBetweenCommands.TAG === /* Ok */0) {
    var millisecondsBetweenTypingCharacter = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenTypingCharacter"), null));
    if (millisecondsBetweenTypingCharacter.TAG === /* Ok */0) {
      var millisecondsBetweenKeyDownKeyUp = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenKeyDownKeyUp"), null));
      if (millisecondsBetweenKeyDownKeyUp.TAG === /* Ok */0) {
        var millisecondsBetweenTypingCharacterAndNonCharacterKeypress = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenTypingCharacterAndNonCharacterKeypress"), null));
        if (millisecondsBetweenTypingCharacterAndNonCharacterKeypress.TAG === /* Ok */0) {
          var useFastestTypePlayback = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "useFastestTypePlayback"), null));
          if (useFastestTypePlayback.TAG === /* Ok */0) {
            var preserveClipboard = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "preserveClipboard"), null));
            if (preserveClipboard.TAG === /* Ok */0) {
              var clipboardBehavior = Decco.optionFromJson(t_decode$5, Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardBehavior"), null));
              if (clipboardBehavior.TAG === /* Ok */0) {
                var startContext = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startContext"), null));
                if (startContext.TAG === /* Ok */0) {
                  var closeWindowWhenFinish = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "closeWindowWhenFinish"), null));
                  if (closeWindowWhenFinish.TAG === /* Ok */0) {
                    var doNotFocus = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "doNotFocus"), null));
                    if (doNotFocus.TAG === /* Ok */0) {
                      var playbackStrategy = t_decode$4(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackStrategy"), null));
                      if (playbackStrategy.TAG === /* Ok */0) {
                        var replaceUiCommandsWithApiCommands = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "replaceUiCommandsWithApiCommands"), null));
                        if (replaceUiCommandsWithApiCommands.TAG === /* Ok */0) {
                          var msBeforeNextCommand = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msBeforeNextCommand"), null));
                          if (msBeforeNextCommand.TAG === /* Ok */0) {
                            var selectorTimeout = Util$SmartcutsMacros.HasDefault.t_decode(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorTimeout"), null));
                            if (selectorTimeout.TAG === /* Ok */0) {
                              var domSnapshots = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domSnapshots"), null));
                              if (domSnapshots.TAG === /* Ok */0) {
                                var doNotShowSplashScreen = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "doNotShowSplashScreen"), null));
                                if (doNotShowSplashScreen.TAG === /* Ok */0) {
                                  return {
                                          TAG: /* Ok */0,
                                          _0: {
                                            millisecondsBetweenCommands: millisecondsBetweenCommands._0,
                                            millisecondsBetweenTypingCharacter: millisecondsBetweenTypingCharacter._0,
                                            millisecondsBetweenKeyDownKeyUp: millisecondsBetweenKeyDownKeyUp._0,
                                            millisecondsBetweenTypingCharacterAndNonCharacterKeypress: millisecondsBetweenTypingCharacterAndNonCharacterKeypress._0,
                                            useFastestTypePlayback: useFastestTypePlayback._0,
                                            preserveClipboard: preserveClipboard._0,
                                            clipboardBehavior: clipboardBehavior._0,
                                            startContext: startContext._0,
                                            closeWindowWhenFinish: closeWindowWhenFinish._0,
                                            doNotFocus: doNotFocus._0,
                                            playbackStrategy: playbackStrategy._0,
                                            replaceUiCommandsWithApiCommands: replaceUiCommandsWithApiCommands._0,
                                            msBeforeNextCommand: msBeforeNextCommand._0,
                                            selectorTimeout: selectorTimeout._0,
                                            domSnapshots: domSnapshots._0,
                                            doNotShowSplashScreen: doNotShowSplashScreen._0
                                          }
                                        };
                                }
                                var e = doNotShowSplashScreen._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".doNotShowSplashScreen" + e.path,
                                          message: e.message,
                                          value: e.value
                                        }
                                      };
                              }
                              var e$1 = domSnapshots._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".domSnapshots" + e$1.path,
                                        message: e$1.message,
                                        value: e$1.value
                                      }
                                    };
                            }
                            var e$2 = selectorTimeout._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".selectorTimeout" + e$2.path,
                                      message: e$2.message,
                                      value: e$2.value
                                    }
                                  };
                          }
                          var e$3 = msBeforeNextCommand._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".msBeforeNextCommand" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                  }
                                };
                        }
                        var e$4 = replaceUiCommandsWithApiCommands._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".replaceUiCommandsWithApiCommands" + e$4.path,
                                  message: e$4.message,
                                  value: e$4.value
                                }
                              };
                      }
                      var e$5 = playbackStrategy._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".playbackStrategy" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                              }
                            };
                    }
                    var e$6 = doNotFocus._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".doNotFocus" + e$6.path,
                              message: e$6.message,
                              value: e$6.value
                            }
                          };
                  }
                  var e$7 = closeWindowWhenFinish._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".closeWindowWhenFinish" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                          }
                        };
                }
                var e$8 = startContext._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".startContext" + e$8.path,
                          message: e$8.message,
                          value: e$8.value
                        }
                      };
              }
              var e$9 = clipboardBehavior._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".clipboardBehavior" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                      }
                    };
            }
            var e$10 = preserveClipboard._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".preserveClipboard" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = useFastestTypePlayback._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".useFastestTypePlayback" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
        }
        var e$12 = millisecondsBetweenTypingCharacterAndNonCharacterKeypress._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".millisecondsBetweenTypingCharacterAndNonCharacterKeypress" + e$12.path,
                  message: e$12.message,
                  value: e$12.value
                }
              };
      }
      var e$13 = millisecondsBetweenKeyDownKeyUp._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".millisecondsBetweenKeyDownKeyUp" + e$13.path,
                message: e$13.message,
                value: e$13.value
              }
            };
    }
    var e$14 = millisecondsBetweenTypingCharacter._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".millisecondsBetweenTypingCharacter" + e$14.path,
              message: e$14.message,
              value: e$14.value
            }
          };
  }
  var e$15 = millisecondsBetweenCommands._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".millisecondsBetweenCommands" + e$15.path,
            message: e$15.message,
            value: e$15.value
          }
        };
}

var defaultPlaybackOptions_millisecondsBetweenCommands = Config$SmartcutsMacros.Default.millisecondsBetweenCommands;

var defaultPlaybackOptions_millisecondsBetweenTypingCharacter = Config$SmartcutsMacros.Default.millisecondsBetweenTypingCharacter;

var defaultPlaybackOptions_millisecondsBetweenKeyDownKeyUp = Config$SmartcutsMacros.Default.millisecondsBetweenKeyDownKeyUp;

var defaultPlaybackOptions_millisecondsBetweenTypingCharacterAndNonCharacterKeypress = Config$SmartcutsMacros.Default.millisecondsBetweenTypingCharacterAndNonCharacterKeypress;

var defaultPlaybackOptions_useFastestTypePlayback = Config$SmartcutsMacros.Default.useFastestTypePlayback;

var defaultPlaybackOptions_clipboardBehavior = /* OnlyUseVirtualClipboard */0;

var defaultPlaybackOptions_replaceUiCommandsWithApiCommands = Config$SmartcutsMacros.Default.replaceUiCommandsWithApiCommands;

var defaultPlaybackOptions_msBeforeNextCommand = [];

var defaultPlaybackOptions_domSnapshots = Config$SmartcutsMacros.Default.domSnapshots;

var defaultPlaybackOptions = {
  millisecondsBetweenCommands: defaultPlaybackOptions_millisecondsBetweenCommands,
  millisecondsBetweenTypingCharacter: defaultPlaybackOptions_millisecondsBetweenTypingCharacter,
  millisecondsBetweenKeyDownKeyUp: defaultPlaybackOptions_millisecondsBetweenKeyDownKeyUp,
  millisecondsBetweenTypingCharacterAndNonCharacterKeypress: defaultPlaybackOptions_millisecondsBetweenTypingCharacterAndNonCharacterKeypress,
  useFastestTypePlayback: defaultPlaybackOptions_useFastestTypePlayback,
  preserveClipboard: false,
  clipboardBehavior: defaultPlaybackOptions_clipboardBehavior,
  startContext: /* StartOnNewWindow */0,
  closeWindowWhenFinish: true,
  doNotFocus: true,
  playbackStrategy: /* ContentScriptOnly */0,
  replaceUiCommandsWithApiCommands: defaultPlaybackOptions_replaceUiCommandsWithApiCommands,
  msBeforeNextCommand: defaultPlaybackOptions_msBeforeNextCommand,
  selectorTimeout: /* Default */0,
  domSnapshots: defaultPlaybackOptions_domSnapshots,
  doNotShowSplashScreen: false
};

var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});

function serialize(opts) {
  return JSON.stringify(opts);
}

function maybeDeserialize(playbackOptionsSchemaVersion, serialized) {
  if (Caml_obj.caml_notequal(playbackOptionsSchemaVersion, schemaVersion)) {
    return ;
  } else {
    return Caml_option.some(JSON.parse(serialized));
  }
}

function substituteIntoPlaybackOptions(overrides, maybeStartContext, maybeMsBeforeNextCommand, playbackOptions) {
  var arg = overrides.millisecondsBetweenCommands;
  var arg$1 = arg === undefined ? undefined : Caml_option.some(arg);
  var arg$2 = overrides.millisecondsBetweenTypingCharacter;
  var arg$3 = arg$2 === undefined ? undefined : Caml_option.some(arg$2);
  var arg$4 = overrides.millisecondsBetweenKeyDownKeyUp;
  var arg$5 = arg$4 === undefined ? undefined : Caml_option.some(arg$4);
  var arg$6 = overrides.millisecondsBetweenTypingCharacterAndNonCharacterKeypress;
  var arg$7 = arg$6 === undefined ? undefined : Caml_option.some(arg$6);
  var arg$8 = overrides.useFastestTypePlayback;
  var arg$9 = arg$8 === undefined ? undefined : Caml_option.some(arg$8);
  var arg$10 = overrides.preserveClipboard;
  var arg$11 = arg$10 === undefined ? undefined : Caml_option.some(arg$10);
  var arg$12 = overrides.clipboardBehavior;
  var arg$13 = arg$12 === undefined ? undefined : Caml_option.some(arg$12);
  var arg$14 = overrides.closeWindowWhenFinish;
  var arg$15 = arg$14 === undefined ? undefined : Caml_option.some(arg$14);
  var arg$16 = overrides.doNotFocus;
  var arg$17 = arg$16 === undefined ? undefined : Caml_option.some(arg$16);
  var arg$18 = overrides.playbackStrategy;
  var arg$19 = arg$18 === undefined ? undefined : Caml_option.some(arg$18);
  var arg$20 = overrides.replaceUiCommandsWithApiCommands;
  var arg$21 = arg$20 === undefined ? undefined : Caml_option.some(arg$20);
  var arg$22 = OptionUtils$SmartcutsMacros.orElse(Caml_option.undefined_to_opt(overrides.msBeforeNextCommand), maybeMsBeforeNextCommand);
  var arg$23 = overrides.selectorTimeout;
  var arg$24 = arg$23 === undefined ? undefined : Caml_option.some(arg$23);
  var arg$25 = overrides.domSnapshots;
  var arg$26 = arg$25 === undefined ? undefined : Caml_option.some(arg$25);
  var arg$27 = overrides.doNotShowSplashScreen;
  var arg$28 = arg$27 === undefined ? undefined : Caml_option.some(arg$27);
  return {
          millisecondsBetweenCommands: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
              })(playbackOptions.millisecondsBetweenCommands),
          millisecondsBetweenTypingCharacter: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$3);
              })(playbackOptions.millisecondsBetweenTypingCharacter),
          millisecondsBetweenKeyDownKeyUp: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$5);
              })(playbackOptions.millisecondsBetweenKeyDownKeyUp),
          millisecondsBetweenTypingCharacterAndNonCharacterKeypress: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$7);
              })(playbackOptions.millisecondsBetweenTypingCharacterAndNonCharacterKeypress),
          useFastestTypePlayback: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$9);
              })(playbackOptions.useFastestTypePlayback),
          preserveClipboard: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$11);
              })(playbackOptions.preserveClipboard),
          clipboardBehavior: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$13);
              })(playbackOptions.clipboardBehavior),
          startContext: OptionUtils$SmartcutsMacros.withDefault(playbackOptions.startContext, maybeStartContext),
          closeWindowWhenFinish: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$15);
              })(playbackOptions.closeWindowWhenFinish),
          doNotFocus: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$17);
              })(playbackOptions.doNotFocus),
          playbackStrategy: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$19);
              })(playbackOptions.playbackStrategy),
          replaceUiCommandsWithApiCommands: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$21);
              })(playbackOptions.replaceUiCommandsWithApiCommands),
          msBeforeNextCommand: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$22);
              })(playbackOptions.msBeforeNextCommand),
          selectorTimeout: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$24);
              })(playbackOptions.selectorTimeout),
          domSnapshots: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$26);
              })(playbackOptions.domSnapshots),
          doNotShowSplashScreen: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$28);
              })(playbackOptions.doNotShowSplashScreen)
        };
}

var SmartcutDefaultPlaybackOptions_t_encode = include.t_encode;

var SmartcutDefaultPlaybackOptions_t_decode = include.t_decode;

var SmartcutDefaultPlaybackOptions = {
  t_encode: SmartcutDefaultPlaybackOptions_t_encode,
  t_decode: SmartcutDefaultPlaybackOptions_t_decode,
  serialize: serialize,
  maybeDeserialize: maybeDeserialize,
  substituteIntoPlaybackOptions: substituteIntoPlaybackOptions
};

function t__encode(v) {
  return Js_dict.fromArray([
              [
                "millisecondsBetweenCommands",
                Decco.optionToJson(Decco.intToJson, v.millisecondsBetweenCommands)
              ],
              [
                "millisecondsBetweenTypingCharacter",
                Decco.optionToJson(Decco.intToJson, v.millisecondsBetweenTypingCharacter)
              ],
              [
                "millisecondsBetweenKeyDownKeyUp",
                Decco.optionToJson(Decco.intToJson, v.millisecondsBetweenKeyDownKeyUp)
              ],
              [
                "millisecondsBetweenTypingCharacterAndNonCharacterKeypress",
                Decco.optionToJson(Decco.intToJson, v.millisecondsBetweenTypingCharacterAndNonCharacterKeypress)
              ],
              [
                "useFastestTypePlayback",
                Decco.optionToJson(Decco.boolToJson, v.useFastestTypePlayback)
              ],
              [
                "preserveClipboard",
                Decco.optionToJson(Decco.boolToJson, v.preserveClipboard)
              ],
              [
                "clipboardBehavior",
                Decco.optionToJson(t_encode$5, v.clipboardBehavior)
              ],
              [
                "startContext",
                Decco.optionToJson(t_encode, v.startContext)
              ],
              [
                "closeWindowWhenFinish",
                Decco.optionToJson(Decco.boolToJson, v.closeWindowWhenFinish)
              ],
              [
                "doNotFocus",
                Decco.optionToJson(Decco.boolToJson, v.doNotFocus)
              ],
              [
                "playbackStrategy",
                Decco.optionToJson(t_encode$4, v.playbackStrategy)
              ],
              [
                "replaceUiCommandsWithApiCommands",
                Decco.optionToJson(Decco.boolToJson, v.replaceUiCommandsWithApiCommands)
              ],
              [
                "msBeforeNextCommand",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(Decco.intToJson, param);
                      }), v.msBeforeNextCommand)
              ],
              [
                "selectorTimeout",
                Decco.optionToJson((function (param) {
                        return Util$SmartcutsMacros.HasDefault.t_encode(Decco.floatToJson, param);
                      }), v.selectorTimeout)
              ],
              [
                "domSnapshots",
                Decco.optionToJson(Decco.boolToJson, v.domSnapshots)
              ],
              [
                "doNotShowSplashScreen",
                Decco.optionToJson(Decco.boolToJson, v.doNotShowSplashScreen)
              ]
            ]);
}

function t__decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var millisecondsBetweenCommands = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenCommands"), null));
  if (millisecondsBetweenCommands.TAG === /* Ok */0) {
    var millisecondsBetweenTypingCharacter = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenTypingCharacter"), null));
    if (millisecondsBetweenTypingCharacter.TAG === /* Ok */0) {
      var millisecondsBetweenKeyDownKeyUp = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenKeyDownKeyUp"), null));
      if (millisecondsBetweenKeyDownKeyUp.TAG === /* Ok */0) {
        var millisecondsBetweenTypingCharacterAndNonCharacterKeypress = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "millisecondsBetweenTypingCharacterAndNonCharacterKeypress"), null));
        if (millisecondsBetweenTypingCharacterAndNonCharacterKeypress.TAG === /* Ok */0) {
          var useFastestTypePlayback = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "useFastestTypePlayback"), null));
          if (useFastestTypePlayback.TAG === /* Ok */0) {
            var preserveClipboard = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "preserveClipboard"), null));
            if (preserveClipboard.TAG === /* Ok */0) {
              var clipboardBehavior = Decco.optionFromJson(t_decode$5, Belt_Option.getWithDefault(Js_dict.get(dict$1, "clipboardBehavior"), null));
              if (clipboardBehavior.TAG === /* Ok */0) {
                var startContext = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startContext"), null));
                if (startContext.TAG === /* Ok */0) {
                  var closeWindowWhenFinish = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "closeWindowWhenFinish"), null));
                  if (closeWindowWhenFinish.TAG === /* Ok */0) {
                    var doNotFocus = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "doNotFocus"), null));
                    if (doNotFocus.TAG === /* Ok */0) {
                      var playbackStrategy = Decco.optionFromJson(t_decode$4, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackStrategy"), null));
                      if (playbackStrategy.TAG === /* Ok */0) {
                        var replaceUiCommandsWithApiCommands = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "replaceUiCommandsWithApiCommands"), null));
                        if (replaceUiCommandsWithApiCommands.TAG === /* Ok */0) {
                          var msBeforeNextCommand = Decco.optionFromJson((function (param) {
                                  return Decco.arrayFromJson(Decco.intFromJson, param);
                                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "msBeforeNextCommand"), null));
                          if (msBeforeNextCommand.TAG === /* Ok */0) {
                            var selectorTimeout = Decco.optionFromJson((function (param) {
                                    return Util$SmartcutsMacros.HasDefault.t_decode(Decco.floatFromJson, param);
                                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectorTimeout"), null));
                            if (selectorTimeout.TAG === /* Ok */0) {
                              var domSnapshots = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domSnapshots"), null));
                              if (domSnapshots.TAG === /* Ok */0) {
                                var doNotShowSplashScreen = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "doNotShowSplashScreen"), null));
                                if (doNotShowSplashScreen.TAG === /* Ok */0) {
                                  return {
                                          TAG: /* Ok */0,
                                          _0: {
                                            millisecondsBetweenCommands: millisecondsBetweenCommands._0,
                                            millisecondsBetweenTypingCharacter: millisecondsBetweenTypingCharacter._0,
                                            millisecondsBetweenKeyDownKeyUp: millisecondsBetweenKeyDownKeyUp._0,
                                            millisecondsBetweenTypingCharacterAndNonCharacterKeypress: millisecondsBetweenTypingCharacterAndNonCharacterKeypress._0,
                                            useFastestTypePlayback: useFastestTypePlayback._0,
                                            preserveClipboard: preserveClipboard._0,
                                            clipboardBehavior: clipboardBehavior._0,
                                            startContext: startContext._0,
                                            closeWindowWhenFinish: closeWindowWhenFinish._0,
                                            doNotFocus: doNotFocus._0,
                                            playbackStrategy: playbackStrategy._0,
                                            replaceUiCommandsWithApiCommands: replaceUiCommandsWithApiCommands._0,
                                            msBeforeNextCommand: msBeforeNextCommand._0,
                                            selectorTimeout: selectorTimeout._0,
                                            domSnapshots: domSnapshots._0,
                                            doNotShowSplashScreen: doNotShowSplashScreen._0
                                          }
                                        };
                                }
                                var e = doNotShowSplashScreen._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".doNotShowSplashScreen" + e.path,
                                          message: e.message,
                                          value: e.value
                                        }
                                      };
                              }
                              var e$1 = domSnapshots._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".domSnapshots" + e$1.path,
                                        message: e$1.message,
                                        value: e$1.value
                                      }
                                    };
                            }
                            var e$2 = selectorTimeout._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".selectorTimeout" + e$2.path,
                                      message: e$2.message,
                                      value: e$2.value
                                    }
                                  };
                          }
                          var e$3 = msBeforeNextCommand._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".msBeforeNextCommand" + e$3.path,
                                    message: e$3.message,
                                    value: e$3.value
                                  }
                                };
                        }
                        var e$4 = replaceUiCommandsWithApiCommands._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".replaceUiCommandsWithApiCommands" + e$4.path,
                                  message: e$4.message,
                                  value: e$4.value
                                }
                              };
                      }
                      var e$5 = playbackStrategy._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".playbackStrategy" + e$5.path,
                                message: e$5.message,
                                value: e$5.value
                              }
                            };
                    }
                    var e$6 = doNotFocus._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".doNotFocus" + e$6.path,
                              message: e$6.message,
                              value: e$6.value
                            }
                          };
                  }
                  var e$7 = closeWindowWhenFinish._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".closeWindowWhenFinish" + e$7.path,
                            message: e$7.message,
                            value: e$7.value
                          }
                        };
                }
                var e$8 = startContext._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".startContext" + e$8.path,
                          message: e$8.message,
                          value: e$8.value
                        }
                      };
              }
              var e$9 = clipboardBehavior._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".clipboardBehavior" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                      }
                    };
            }
            var e$10 = preserveClipboard._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".preserveClipboard" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = useFastestTypePlayback._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".useFastestTypePlayback" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
        }
        var e$12 = millisecondsBetweenTypingCharacterAndNonCharacterKeypress._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".millisecondsBetweenTypingCharacterAndNonCharacterKeypress" + e$12.path,
                  message: e$12.message,
                  value: e$12.value
                }
              };
      }
      var e$13 = millisecondsBetweenKeyDownKeyUp._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".millisecondsBetweenKeyDownKeyUp" + e$13.path,
                message: e$13.message,
                value: e$13.value
              }
            };
    }
    var e$14 = millisecondsBetweenTypingCharacter._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".millisecondsBetweenTypingCharacter" + e$14.path,
              message: e$14.message,
              value: e$14.value
            }
          };
  }
  var e$15 = millisecondsBetweenCommands._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".millisecondsBetweenCommands" + e$15.path,
            message: e$15.message,
            value: e$15.value
          }
        };
}

function make(millisecondsBetweenCommands, millisecondsBetweenTypingCharacter, millisecondsBetweenKeyDownKeyUp, millisecondsBetweenTypingCharacterAndNonCharacterKeypress, useFastestTypePlayback, preserveClipboard, clipboardBehavior, closeWindowWhenFinish, doNotFocus, playbackStrategy, replaceUiCommandsWithApiCommands, msBeforeNextCommand, selectorTimeout, domSnapshots, doNotShowSplashScreen, param) {
  return {
          millisecondsBetweenCommands: millisecondsBetweenCommands,
          millisecondsBetweenTypingCharacter: millisecondsBetweenTypingCharacter,
          millisecondsBetweenKeyDownKeyUp: millisecondsBetweenKeyDownKeyUp,
          millisecondsBetweenTypingCharacterAndNonCharacterKeypress: millisecondsBetweenTypingCharacterAndNonCharacterKeypress,
          useFastestTypePlayback: useFastestTypePlayback,
          preserveClipboard: preserveClipboard,
          clipboardBehavior: clipboardBehavior,
          startContext: undefined,
          closeWindowWhenFinish: closeWindowWhenFinish,
          doNotFocus: doNotFocus,
          playbackStrategy: playbackStrategy,
          replaceUiCommandsWithApiCommands: replaceUiCommandsWithApiCommands,
          msBeforeNextCommand: msBeforeNextCommand,
          selectorTimeout: selectorTimeout,
          domSnapshots: domSnapshots,
          doNotShowSplashScreen: doNotShowSplashScreen
        };
}

function substituteIntoPlaybackOptions$1(overrides, startContext, msBeforeNextCommand, playbackOptions) {
  var arg = overrides.millisecondsBetweenCommands;
  var arg$1 = overrides.millisecondsBetweenTypingCharacter;
  var arg$2 = overrides.millisecondsBetweenKeyDownKeyUp;
  var arg$3 = overrides.millisecondsBetweenTypingCharacterAndNonCharacterKeypress;
  var arg$4 = overrides.useFastestTypePlayback;
  var arg$5 = overrides.preserveClipboard;
  var arg$6 = overrides.clipboardBehavior;
  var arg$7 = overrides.closeWindowWhenFinish;
  var arg$8 = overrides.doNotFocus;
  var arg$9 = overrides.playbackStrategy;
  var arg$10 = overrides.replaceUiCommandsWithApiCommands;
  var arg$11 = overrides.selectorTimeout;
  var arg$12 = overrides.domSnapshots;
  var arg$13 = overrides.doNotShowSplashScreen;
  return {
          millisecondsBetweenCommands: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })(playbackOptions.millisecondsBetweenCommands),
          millisecondsBetweenTypingCharacter: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
              })(playbackOptions.millisecondsBetweenTypingCharacter),
          millisecondsBetweenKeyDownKeyUp: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
              })(playbackOptions.millisecondsBetweenKeyDownKeyUp),
          millisecondsBetweenTypingCharacterAndNonCharacterKeypress: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$3);
              })(playbackOptions.millisecondsBetweenTypingCharacterAndNonCharacterKeypress),
          useFastestTypePlayback: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$4);
              })(playbackOptions.useFastestTypePlayback),
          preserveClipboard: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$5);
              })(playbackOptions.preserveClipboard),
          clipboardBehavior: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$6);
              })(playbackOptions.clipboardBehavior),
          startContext: startContext,
          closeWindowWhenFinish: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$7);
              })(playbackOptions.closeWindowWhenFinish),
          doNotFocus: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$8);
              })(playbackOptions.doNotFocus),
          playbackStrategy: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$9);
              })(playbackOptions.playbackStrategy),
          replaceUiCommandsWithApiCommands: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$10);
              })(playbackOptions.replaceUiCommandsWithApiCommands),
          msBeforeNextCommand: msBeforeNextCommand,
          selectorTimeout: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$11);
              })(playbackOptions.selectorTimeout),
          domSnapshots: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$12);
              })(playbackOptions.domSnapshots),
          doNotShowSplashScreen: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg$13);
              })(playbackOptions.doNotShowSplashScreen)
        };
}

function prepopulateWithSmartcutDefaultPlaybackOptions(smartcutDefaultPlaybackOptions, defaultPlaybackOptionsOpt, param) {
  var defaultPlaybackOptions$1 = defaultPlaybackOptionsOpt !== undefined ? defaultPlaybackOptionsOpt : defaultPlaybackOptions;
  var arg = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.millisecondsBetweenCommands);
        }));
  var arg$1 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.millisecondsBetweenTypingCharacter);
        }));
  var arg$2 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.millisecondsBetweenKeyDownKeyUp);
        }));
  var arg$3 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.millisecondsBetweenTypingCharacterAndNonCharacterKeypress);
        }));
  var arg$4 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.useFastestTypePlayback);
        }));
  var arg$5 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.preserveClipboard);
        }));
  var arg$6 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.clipboardBehavior);
        }));
  var arg$7 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.closeWindowWhenFinish);
        }));
  var arg$8 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.doNotFocus);
        }));
  var arg$9 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.playbackStrategy);
        }));
  var arg$10 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.replaceUiCommandsWithApiCommands);
        }));
  var arg$11 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.msBeforeNextCommand);
        }));
  var arg$12 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.selectorTimeout);
        }));
  var arg$13 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.domSnapshots);
        }));
  var arg$14 = Belt_Option.flatMap(smartcutDefaultPlaybackOptions, (function (prim) {
          return Caml_option.undefined_to_opt(prim.doNotShowSplashScreen);
        }));
  return {
          millisecondsBetweenCommands: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg);
              })(defaultPlaybackOptions$1.millisecondsBetweenCommands),
          millisecondsBetweenTypingCharacter: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$1);
              })(defaultPlaybackOptions$1.millisecondsBetweenTypingCharacter),
          millisecondsBetweenKeyDownKeyUp: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$2);
              })(defaultPlaybackOptions$1.millisecondsBetweenKeyDownKeyUp),
          millisecondsBetweenTypingCharacterAndNonCharacterKeypress: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$3);
              })(defaultPlaybackOptions$1.millisecondsBetweenTypingCharacterAndNonCharacterKeypress),
          useFastestTypePlayback: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$4);
              })(defaultPlaybackOptions$1.useFastestTypePlayback),
          preserveClipboard: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$5);
              })(defaultPlaybackOptions$1.preserveClipboard),
          clipboardBehavior: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$6);
              })(defaultPlaybackOptions$1.clipboardBehavior),
          startContext: undefined,
          closeWindowWhenFinish: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$7);
              })(defaultPlaybackOptions$1.closeWindowWhenFinish),
          doNotFocus: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$8);
              })(defaultPlaybackOptions$1.doNotFocus),
          playbackStrategy: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$9);
              })(defaultPlaybackOptions$1.playbackStrategy),
          replaceUiCommandsWithApiCommands: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$10);
              })(defaultPlaybackOptions$1.replaceUiCommandsWithApiCommands),
          msBeforeNextCommand: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$11);
              })(defaultPlaybackOptions$1.msBeforeNextCommand),
          selectorTimeout: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$12);
              })(defaultPlaybackOptions$1.selectorTimeout),
          domSnapshots: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$13);
              })(defaultPlaybackOptions$1.domSnapshots),
          doNotShowSplashScreen: (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$14);
              })(defaultPlaybackOptions$1.doNotShowSplashScreen)
        };
}

function stringify$1(userSpecifiedPlaybackOptions) {
  return JSON.stringify(t__encode(userSpecifiedPlaybackOptions));
}

var UserSpecifiedPlaybackOptions = {
  t__encode: t__encode,
  t__decode: t__decode,
  make: make,
  substituteIntoPlaybackOptions: substituteIntoPlaybackOptions$1,
  prepopulateWithSmartcutDefaultPlaybackOptions: prepopulateWithSmartcutDefaultPlaybackOptions,
  stringify: stringify$1
};

function substituteInUserSpecifiedAndSmartcutDefaultOverrides(userSpecifiedPlaybackOptions, maybeSmartcutDefaultPlaybackOptions, startContext, msBeforeNextCommand, playbackOptions) {
  if (maybeSmartcutDefaultPlaybackOptions === undefined) {
    return substituteIntoPlaybackOptions$1(userSpecifiedPlaybackOptions, startContext, msBeforeNextCommand, playbackOptions);
  }
  var smartcutDefaultPlaybackOptions = Caml_option.valFromOption(maybeSmartcutDefaultPlaybackOptions);
  var arg = function (param, param$1, param$2) {
    return substituteIntoPlaybackOptions(smartcutDefaultPlaybackOptions, param, param$1, param$2);
  };
  return substituteIntoPlaybackOptions$1(userSpecifiedPlaybackOptions, startContext, msBeforeNextCommand, arg(undefined, undefined, playbackOptions));
}

function stringify$2(param) {
  return "{millisecondsBetweenCommands: " + (String(param.millisecondsBetweenCommands) + (", millisecondsBetweenTypingCharacter: " + (String(param.millisecondsBetweenTypingCharacter) + (", millisecondsBetweenKeyDownKeyUp: " + (String(param.millisecondsBetweenKeyDownKeyUp) + (", millisecondsBetweenTypingCharacterAndNonCharacterKeypress: " + (String(param.millisecondsBetweenTypingCharacterAndNonCharacterKeypress) + (", useFastestTypePlayback: " + (Pervasives.string_of_bool(param.useFastestTypePlayback) + (", preserveClipboard: " + (Pervasives.string_of_bool(param.preserveClipboard) + (", closeWindowWhenFinish: " + (Pervasives.string_of_bool(param.closeWindowWhenFinish) + (", doNotFocus: " + (Pervasives.string_of_bool(param.doNotFocus) + (", startContext: " + (stringify(param.startContext) + (", playbackStrategy: '<elided>', replaceUiCommandsWithApiCommands: " + (Pervasives.string_of_bool(param.replaceUiCommandsWithApiCommands) + (", domSnapshots: " + (Pervasives.string_of_bool(param.domSnapshots) + "}")))))))))))))))))))));
}

exports.schemaVersion = schemaVersion;
exports.StartContext = StartContext;
exports.HybridPlaybackStrategy__PasteStrategy = HybridPlaybackStrategy__PasteStrategy;
exports.HybridPlaybackStrategy = HybridPlaybackStrategy;
exports.PlaybackStrategy = PlaybackStrategy;
exports.ClipboardBehavior = ClipboardBehavior;
exports.t_encode = t_encode$6;
exports.t_decode = t_decode$6;
exports.defaultPlaybackOptions = defaultPlaybackOptions;
exports.SmartcutDefaultPlaybackOptions = SmartcutDefaultPlaybackOptions;
exports.UserSpecifiedPlaybackOptions = UserSpecifiedPlaybackOptions;
exports.substituteInUserSpecifiedAndSmartcutDefaultOverrides = substituteInUserSpecifiedAndSmartcutDefaultOverrides;
exports.stringify = stringify$2;
/* include Not a pure module */
